<!--
 * @Author: 
 * @Date: 2022-06-29 08:57:28
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-02 15:58:23
 * @FilePath: /Cup2Supplier/Users/onepisya/Documents/GitHub/jdhl_work/Cup2Market/src/components/card/components/CardTitle.vue
 * @Description: 
this.data.activityReward 活动类型
this.data.state 状态

partId: this.data.partId,
actId: this.data.actId,
partGoodsId: this.data.partGoodsId,
goodsId: this.data.goodsId,

title: this.data.goodsName,
desc: this.data.activityName,
imgUrl: this.data.goodsImg,

this.coupons 折扣券 满减优惠之类的标记 couponsName
activityState 活动状态
-->
<template>
  <div class="title-wrapper content-center">
    <div class="title-wrapper-l">
      <div class="title">
        <!-- 标题前面的 各种icon -->
        <slot name="icon">
          <!-- activityReward 可选项如果没有传递则没有 标题前缀图标 -->
          <template
            v-if="
              data.activityReward === 'COMMISSION' &&
              $store.state.user.distributionFlag
            "
          >
            <iframe
              class="svg-img"
              :src="require('@/assets/goodsdetail/双倍佣金.svg')"
            ></iframe>
          </template>
          <template v-if="data.activityReward === 'AWARD'">
            <iframe
              class="svg-img"
              :src="require('@/assets/goodsdetail/抽奖专场.svg')"
            ></iframe>
          </template>
          <template v-if="data.activityReward === 'NEWBIE'">
            <iframe
              class="svg-img"
              :src="require('@/assets/goodsdetail/新人专场.svg')"
            ></iframe>
          </template>
        </slot>
        <!-- 产品名字 -->
        <slot name="name">
          <span class="title-text">{{ data.goodsName }}</span>
        </slot>
      </div>
      <!-- 关于比如 满减 优惠券之类的标记 -->
      <div class="row-tips">
        <span
          ref="myTips"
          class="tips"
          v-for="(item, index) in coupons"
          :key="index"
        >
          <slot name="tips">
            {{ item.couponName }}
          </slot>
        </span>
      </div>
    </div>
    <!-- 分享按钮 -->
    <div
      class="title-wrapper-r flex"
      v-distributor="true"
      @click.stop="shareClick"
    >
      <slot name="shareIcon">
        <img
          v-if="activityState"
          :src="require('@/assets/activityplace/goods_share.svg')"
        />
        <img
          v-else
          :src="require('@/assets/activityplace/goods_share_green.svg')"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import { typeCheck } from "@/utils/index";

export default {
  name: "CardTitle",
  methods: {
    shareClick() {
      if (this.data.state === "FINISHED") {
        Toast({
          message: "活动已结束",
          position: "center",
          duration: 1000,
        });
        return;
      }
      this.$store.dispatch("shareGoods/show", {
        params: {
          partId: this.data.partId,
          actId: this.data.actId,
          partGoodsId: this.data.partGoodsId,
          goodsId: this.data.goodsId,
        },
        shareOptions: {
          title: this.data.goodsName,
          desc: this.data.activityName,
          imgUrl: this.data.goodsImg,
        },
      });
    },
  },
  computed: {
    activityState() {
      const myTips = this.$refs.myTips;
      if (typeCheck(myTips) === "array") {
        if (this.$attrs.activityState === false) {
          myTips[0].classList.add("pre-tips");
        } else {
          myTips[0].classList.remove("pre-tips");
        }
      } else if (myTips !== undefined) {
        console.log("myTips is not array", typeCheck(myTips));
        if (this.$attrs.activityState === false) {
          myTips.classList.add("pre-tips");
        } else {
          myTips.classList.remove("pre-tips");
        }
      }
      return this.$attrs.activityState;
    },
    data() {
      return this.$attrs.data;
    },
    coupons() {
      return this.$attrs.coupons;
    },
  },
};
</script>

<style lang="less" scoped>
.title-wrapper {
  @title-wrapper-height: 58px;
  @title-height: 40px;
  display: flex;
  justify-content: space-between;
  padding: 0 6px;
  &-l {
    /* px-to-viewport-ignore-next */
    height: @title-wrapper-height;
    flex: 1;
    min-width: 0;
    .title {
      /* px-to-viewport-ignore-next */
      height: @title-height;
      display: flex;
      align-items: center;
      /* px-to-viewport-ignore-next */
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      /* px-to-viewport-ignore-next */
      line-height: 20px;
      /* px-to-viewport-ignore-next */
      // padding-bottom: 4px;

      .title-text {
        /* px-to-viewport-ignore-next */
        // height: @title-height;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box !important;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
      }
      .svg-img {
        display: inline-block;
        height: 30px;
        width: 104px;
        margin-right: 8px;
      }
    }
    .row-tips {
      /* px-to-viewport-ignore-next */
      height: 18px;
      .tips {
        box-sizing: border-box;
        /* px-to-viewport-ignore-next */
        font-size: 12px;
        /* px-to-viewport-ignore-next */
        height: 18px;
        /* px-to-viewport-ignore-next */
        line-height: 18px;
        color: var(--sale-status-color);
        border: 1px solid var(--sale-status-color);
        /* px-to-viewport-ignore-next */
        border-radius: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
      }

      .pre-tips {
        color: var(--pre-sale-status-color);
        border: 1px solid var(--pre-sale-status-color);
        /* px-to-viewport-ignore-next */
        padding: 0 4px;
      }
    }
  }
  &-r {
    img {
      /* px-to-viewport-ignore-next */
      height: 40px;
      /* px-to-viewport-ignore-next */
      width: 40px;
    }
  }
}
</style>
